// AffiliateDetailsPage.tsx
import React, { useEffect, useState } from "react";
import { data, useParams } from "react-router-dom";
import { Box, Typography, Card, CardContent, Divider } from "@mui/material";
import BasicTable from "@diditusa/shared/web_components/BasicTable/BasicTable";
import {
  AffiliateJobs,
  InvitedUser,
} from "@diditusa/shared/types/affiliateTypes";
import { BasicTableHeader } from "../../../../shared/types/commonTypes";
import adminApi from "@diditusa/shared/api/adminApi";

// Stubbed API fetch function
const fetchAffiliateById = async (id: string) => {
  return {
    id,
    name: "Jane Doe",
    email: "jane@example.com",
    token: "abc123",
    phoneNumber: "123-456-7890",
    users: [
      { id: 1, name: "User One", email: "user1@example.com" },
      { id: 2, name: "User Two", email: "user2@example.com" },
    ],
    commissions: [
      { id: 1, job: "Event Security", amount: 150, status: "Paid" },
      { id: 2, job: "Night Club Escort", amount: 200, status: "Unpaid" },
    ],
  };
};

const AffiliateDetailsPage: React.FC = () => {
  const { affiliateId } = useParams<{ affiliateId: string }>();
  const [getAffiliateById, { data: affiliate, ...getAffiliateState }] =
    adminApi.useLazyAdminGetAffiliateByIdQuery();

  useEffect(() => {
    if (affiliateId) {
      getAffiliateById(parseInt(affiliateId));
    }
  }, [affiliateId]);

  if (!affiliate) return <Typography>Loading affiliate data...</Typography>;

  type InvitedUserKey = keyof InvitedUser;
  type JobsKey = keyof AffiliateJobs;
  const userHeaders: BasicTableHeader<InvitedUserKey>[] = [
    { key: "firstName", value: "First Name" },
    { key: "lastName", value: "Last Name" },
    { key: "createdAt", value: "Added On" },
  ];
  const jobsHeaders: BasicTableHeader<JobsKey>[] = [
    { key: "id", value: "id" },
    { key: "title", value: "Package" },
    { key: "startTime", value: "Start Time" },
    { key: "jobStatus", value: "Job Status" },
    { key: "status", value: "Payment Status" },
  ];
  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        Affiliate Details
      </Typography>
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6">{affiliate.name}</Typography>
          <Typography>Email: {affiliate.email}</Typography>
          <Typography>Phone: {affiliate.phoneNumber || "N/A"}</Typography>
          <Typography>
            Token: <code>{affiliate.token}</code>
          </Typography>
          <Typography>
            Link: {`https://saef.app/invites/${affiliate.token}`}
          </Typography>
        </CardContent>
      </Card>

      <Typography variant="h6" gutterBottom>
        Referred Users
      </Typography>
      {affiliate.invitedUsers ? (
        <BasicTable headers={userHeaders} data={affiliate.invitedUsers} />
      ) : (
        <p>No users joined by affiliate</p>
      )}

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" gutterBottom>
        Commissionable Jobs
      </Typography>
      {affiliate.jobs ? (
        <BasicTable headers={jobsHeaders} data={affiliate.jobs} />
      ) : (
        <p>No jobs have been completed by this affiliates invitees</p>
      )}
    </Box>
  );
};

export default AffiliateDetailsPage;
